/*
 * PaperClip custom storefront JS.
 *
 * Two unrelated features live in this file. Keep them that way — they are not connected, and
 * breaking one while editing the other is the most likely way to take down a working feature:
 *
 *   1. Webinar certificate claim  — /pages/certificate (see templates/page.certificate.liquid)
 *   2. Handouts password gate     — /pages/handouts (see sections/password-access.liquid)
 *
 * TICK-3339 (2026-08): rewritten from the previous single-line build. Changes:
 *   - The certificate UI moved from a sitewide modal to its own page, so the modal open/close
 *     handlers are gone. Everything else about the certificate flow behaves as before.
 *   - Webinar sorting now uses the `data-ts` unix timestamp rendered by Liquid instead of
 *     parsing "October 13, 2026" with `new Date()`. That parse succeeded in Chrome and returned
 *     NaN in Firefox and Safari, which collapsed the comparison and left webinars out of order —
 *     the bug Kelsi reported on 2025-03-28.
 *   - The handouts password gate below is unchanged in behaviour. Do not "tidy" it; see the note.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // 1. Webinar certificate claim
  // ---------------------------------------------------------------------------

  var $select = $('#product-title');

  if ($select.length) {
    // Liquid renders data-ts as a unix timestamp. Anything unparseable sorts to the bottom
    // rather than corrupting the comparison.
    var timestampOf = function (el) {
      var ts = parseInt($(el).attr('data-ts'), 10);
      return isNaN(ts) ? 0 : ts;
    };

    var nowTs = Math.floor(Date.now() / 1000);
    var options = $select.find('option').get();

    options.sort(function (a, b) {
      return timestampOf(b) - timestampOf(a);
    });

    $select.empty();

    // Certificates are only claimable for webinars that have already taken place.
    options.forEach(function (option) {
      var ts = timestampOf(option);
      if (ts > 0 && ts < nowTs) {
        $select.append(option);
      }
    });

    $select.val($select.find('option:first').val());
  }

  var showCertificateError = function (message) {
    $('.alert__error-item').html(message);
    $('.alert.alert--error').removeClass('hideMe');
  };

  $('.form__submit__certificate').on('click', function (event) {
    event.preventDefault();

    $('.alert.alert--error').addClass('hideMe');

    var $selected = $('#product-title option:selected');

    if (!$selected.length) {
      showCertificateError('Please select a webinar.');
      return;
    }

    var enteredPassword = $('#password').val();
    var institution = $('#institution').val();
    var title = $('#title').val();

    if (!institution.length || !title.length || !enteredPassword.length) {
      showCertificateError('Please make sure all the fields are filled in.');
      return;
    }

    if (enteredPassword !== $selected.attr('code')) {
      showCertificateError("Password didn't match. Please check the password on your instructions sheet.");
      return;
    }

    $('#cert-container-pdf').removeClass('hideMe');
    $('#cert-container-pdf .webinaryName').html($select.val());
    $('#cert-container-pdf .webinarySubtitle').html($selected.attr('subtitle'));
    $('#cert-container-pdf .date').html($selected.attr('date'));
    $('#cert-container-pdf .institutionName').html(institution);

    // Tag the customer with their stated title and institution. Best-effort — a failure here
    // must not stop the certificate downloading.
    $.ajax({
      url: 'https://paper-clip-taggerf.gadget.app/tags',
      method: 'post',
      data: {
        id: $('#customer-id').val(),
        tags: 'title-' + title + ', institution-' + institution + ', certificate'
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Error updating customer account:', errorThrown);
      }
    });

    html2pdf(document.getElementById('cert-container-pdf'), {
      margin: [0, 0, 0, 0],
      filename: 'paperclip-certificate.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { dpi: 500, letterRendering: true },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
    }).then(function () {
      $('#cert-container-pdf').addClass('hideMe');
    });
  });

  // ---------------------------------------------------------------------------
  // 2. Handouts password gate  (/pages/handouts)
  // ---------------------------------------------------------------------------
  //
  // The password is stored as a cart attribute so sections/password-access.liquid can read it
  // server-side and match it against the `code:` tag on the webinar product.
  //
  // The clear-on-load below is deliberate and load-bearing. By the time it runs, Liquid has
  // already rendered the page using the attribute, so the customer sees their files — and the
  // attribute is then wiped, which is what makes access one page view long rather than sticky
  // for the rest of the session. Removing it silently turns a one-shot gate into a persistent
  // one.

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { password: '' } })
  }).catch(function (error) {
    console.error('Error clearing handout password attribute:', error);
  });

  var passwordButton = document.getElementById('password-protection');

  if (passwordButton) {
    passwordButton.addEventListener('click', function () {
      var password = document.getElementById('password-protection-input').value;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { password: password } })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function (error) {
          console.error('Error setting handout password attribute:', error);
        });
    });
  }
})();
